export const Width = {
  wrapper: "1500px",
}
